export default __webpack_public_path__ + "static/media/references__konzultant.fda62588.jpg";